const submitCeligoOptOutRequest = async (formValues) => {
  try {
    const response = await fetch('/api/celigoOptOutRequest', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        formValues
      })
    });

    if (!response.ok) {
      const errorBody = await response.json().catch(() => ({}));
      const message = errorBody.error || 'Failed to submit opt out request';
      throw new Error(message);
    }

    return { success: true };
  } catch (error) {
    console.error('Error submitting opt out request:', error);
    return { success: false, error };
  }
};

export { submitCeligoOptOutRequest };
